module.exports = __webpack_public_path__ + "static/media/Neuzeit-01.92f19228.svg";